export default {
  metrics: {
    pickup: 'Odbiór osobisty',
    internal_delivery: 'Dostawa własna',
    external_delivery: 'Dostawa zewnętrzna',
  },
  events: {
    add_to_basket: 'Dodaj produkt',
    begin_checkout: 'Przejdź do kasy',
    begin_purchase: 'Zainicjuj płatność',
    complete_purchase: 'Sfinalizuj płatność',
    order_placed: 'Sfinalizuj płatność',
    view_item: 'Wyświetl produkt',
  },
};
